import React from "react"
import { BrowserRouter, Route, Routes, Link } from "react-router-dom"
import Content from "./content"
import Kanban from "./kanban"
import Sidebar from "./sidebar"
import Csv from "./csv"
import MoSidebar from "./moSidebar"
const commonjs = require("./../js/common.js")

const App = () => {
	const boapiLink = () => {
		window.location.href = "/"
	}
	const foapiLink = () => {
		window.location.href = "/"
	}
	return (
		<>
			<BrowserRouter>
				<div className="app" onClick={commonjs.HandlePage.bind(null, this)}>
					<div className="wtop">
						<div className="m_menu">
							<MoSidebar />
						</div>
						<div className="logo pointer" onClick={foapiLink.bind(null, this)}></div>
						<div className="flex_a px-4 sm:px-6">
							<ul className="border-slate-200 space-x-6 flex whitespace-nowrap dark:border-slate-200/5 mb-px">
								<li>
									<h2>
										<Link className="flex text-sm leading-6 font-semibold pt-3 pb-2.5 border-b-2 -mb-px text-sky-500 border-current" to="https://api.x2bee.com/" target="_blank">
											FO API
										</Link>
									</h2>
								</li>
								<li>
									<h2>
										<Link rel="noopener noreferrer" className="flex text-sm leading-6 font-semibold pt-3 pb-2.5 border-b-2 -mb-px text-slate-900 border-transparent hover:border-slate-300 dark:text-slate-200 dark:hover:border-slate-700" to="https://apibo.x2bee.com/" target="_blank">
											BO API
										</Link>
									</h2>
								</li>
							</ul>
							<span className="back">
								<Link rel="noopener noreferrer" className="top-btn-bg-color" to="https://tech.x2bee.com/" target="_blank">
									테크허브 &nbsp;<span aria-hidden="true">→</span>
								</Link>
							</span>
						</div>
					</div>
					<Sidebar />
					<div className="mt84">
					<div className="wbg">
						<Routes>
							<Route path="/" element={<Kanban />} />
							<Route path="/kanban" element={<Kanban />} />
							<Route path="/content" element={<Content />} />
							<Route path="/csv" element={<Csv />} />
						</Routes>
					</div>
					</div>
				</div>
			</BrowserRouter>
		</>
	)
}

export default App
